<mat-sidenav-container>
  <!-- notifications sidebar -->
  <mat-sidenav #notifications_sidenav [position]="'end'" (closed)="onCloseNotificationCenter()">
    <ng-container *ngIf="isNotificationCenterOpen">
      <app-notifications-list (closeNotificationCenterEvent)="notifications_sidenav.close()"></app-notifications-list>
    </ng-container>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="side-nav" [attr.isCollapsed]="isCollapsed ? '1' : '0'">
      <app-side-nav-bar></app-side-nav-bar>
    </div>
    <div class="container" [attr.isCollapsed]="isCollapsed ? '1' : '0'">
      <!-- start header -->
      <div class="header" #header>
        <app-header></app-header>
      </div>
      <!-- end header -->
      <div class="content" [style.padding-top]="header.offsetHeight + 'px'">
        <!-- <div class="content-wrapper"> -->
        <!-- start main layout page and inject router outlet inside it's content -->
        <app-main-layout-page [isSideNavCollapsed]="isCollapsed">
          <app-router></app-router>
        </app-main-layout-page>
        <!-- end main layout page  -->
        <!-- </div> -->
        <!-- <p *ngFor="let i of list">
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odio magnam eveniet sit nulla vero, possimus cum officia iste soluta veritatis
          fugiat sequi id ullam odit libero at deleniti modi et.
        </p> -->
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<ng-template #dynamicComponent></ng-template>
